<template>
  <div 
      class="profile-menu"
      data-qa="profile-menu"
  >
    <button class="profile-menu__trigger" ref="triggerRef">
      <span>{{ username }}</span>
      <svg-icon icon="lh:chevron/down" width="12" height="12"></svg-icon>
    </button>
    <tippy v-if="menu"
           interactive
           animation="fade"
           theme="default default-main-menu"
           :to-element="triggerRef"
           arrow
           arrow-type="round"
    >
      <template #default>
        <div
            class="profile-menu__menu"
            data-qa="profile-menu__menu"
        >
          <template v-for="(item, index) in menu.items">
            <div v-if="item.type === $options.SEPARATOR" :key="`sep-${index}`" class="profile-menu__divider"></div>
            <div v-else :key="`item-${index}`" class="profile-menu__item">
              <a :href="item.targetUrl !== '#' ? item.targetUrl : undefined"
                 :target="item.isLocalUrl ? '_self' : '_blank'" >
                {{ item.title }}
              </a>
            </div>
          </template>
        </div>
      </template>
    </tippy>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import {MenuItemType} from "../types"

export default {
  components: {
    SvgIcon,
  },
  props: {
    username: String,
    menu: Object,
  },
  SEPARATOR: MenuItemType.Separator,
  data() {
    return {
      triggerRef: null,
    };
  },
  mounted() {
    this.triggerRef = this.$refs.triggerRef;
  },
}
</script>

<style lang="scss" scoped>
.profile-menu {
  position: relative;
}

.profile-menu__trigger {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  line-height: 20px;
  height: 20px;
  width: 100%;
  color: var(--main-10);
  text-align: start;

  > :nth-child(1) {
    flex: 1 1 100%;
    min-width: 1px;
  }

  > svg {
    flex: 0 0 auto;
  }
}

.profile-menu__menu {

}

.profile-menu__item {
  font-size: 13px;
  line-height: 20px;
  min-width: 150px;
  
  padding: 2px 4px;
  border-radius: var(--border-radius-sm);
  
  > * {
    color: inherit;
    display: block;
    user-select: none;
  }
  
  &:hover {
    background-color: var(--main-10);
    color: var(--white) !important;
  }
}

.profile-menu__divider {
  border-top: 2px solid var(--main-40);
  margin: 8px 0 5px;
}

</style>
